<template>
	<div data-tour-scope="setting-storage">
		<v-main>
			<v-container fluid fill-height>
				<v-layout justify-center align-center>
					<v-card width="100%" outlined elevation-0>
						<v-toolbar flat class="border_bottom" shaped>
							<v-toolbar-title>Storage</v-toolbar-title>
							<v-btn class="ml-6" outlined color="primary" data-tour="tutorial" @click="tour.start()"><v-icon left>mdi-school-outline</v-icon>Tutorial guidato</v-btn>
							<v-spacer></v-spacer>
						</v-toolbar>
						<StorageServices />
					</v-card>
				</v-layout>
			</v-container>
		</v-main>
		<TourOverlay :tour="tour"></TourOverlay>
	</div>
</template>

<script>
import TourOverlay from '@/components/core/tour/TourOverlay.vue';
import { useTour } from '@/components/core/tour/useTour';
import StorageServices from './components/StorageServices.vue';
import { createStorageSettingsTourSteps, stopStorageSettingsTour } from './storage-settings-tour';

/*
 * Impostazioni > Storage: dove finiscono foto e file del negozio. Di default lo storage di AzSeller
 * (variabili d'ambiente del backend); il cliente puo' collegare il proprio bucket S3 con CloudFront.
 */
export default {
	name: 'SettingStorage',
	components: { TourOverlay, StorageServices },
	setup() {
		return { tour: useTour(createStorageSettingsTourSteps(), { onStop: stopStorageSettingsTour }) };
	},
	beforeDestroy() {
		this.tour.stop();
	},
};
</script>
